import React from "react";
import { motion } from "framer-motion";

/**
 * Scroll-reveal wrapper. Smoothly fades + slides content up when
 * it first enters the viewport. Triggers once.
 */
export default function Reveal({
    children,
    delay = 0,
    y = 32,
    duration = 0.8,
    className = "",
    once = true,
    amount = 0.2,
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount }}
            transition={{
                delay,
                duration,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
